import { render, staticRenderFns } from "./AccountsGet.vue?vue&type=template&id=0ef334d6&"
import script from "./AccountsGet.vue?vue&type=script&lang=js&"
export * from "./AccountsGet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports